console.log("Checking testDoppeltorMitEckadapter1");
